// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProtocolAssessment
 */
export interface ProtocolAssessment {
    /**
     * 
     * @type {string}
     * @memberof ProtocolAssessment
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolAssessment
     */
    name: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof ProtocolAssessment
     */
    scheduled_visits?: Array<number>;
}

/**
 * Check if a given object implements the ProtocolAssessment interface.
 */
export function instanceOfProtocolAssessment(value: object): value is ProtocolAssessment {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function ProtocolAssessmentFromJSON(json: any): ProtocolAssessment {
    return ProtocolAssessmentFromJSONTyped(json, false);
}

export function ProtocolAssessmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolAssessment {
    if (json == null) {
        return json;
    }
    return {
        
        'category': json['category'] == null ? undefined : json['category'],
        'name': json['name'],
        'scheduled_visits': json['scheduled_visits'] == null ? undefined : json['scheduled_visits'],
    };
}

export function ProtocolAssessmentToJSON(json: any): ProtocolAssessment {
    return ProtocolAssessmentToJSONTyped(json, false);
}

export function ProtocolAssessmentToJSONTyped(value?: ProtocolAssessment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'category': value['category'],
        'name': value['name'],
        'scheduled_visits': value['scheduled_visits'],
    };
}
